<template>
    <AdminLayout>
        <section class="grid grid-cols-7">
            <div class="col-span-5 py-2 px-10">
                <div class="mt-12">
                    <div class="border rounded-lg py-7 px-8">
                        <div class="flex justify-between mb-8">
                            <p class="font-semibold text-xl text-neutral-800">Leave Details</p>
                        </div>
                        <!-- Skeleton Loader -->
                        <div v-if="loading" class="space-y-9 animate-pulse">
                            <div class="relative w-36 h-28 rounded-md bg-gray-200"></div>
                            
                            <div class="grid grid-cols-3 gap-x-6 gap-y-9">
                                <div class="h-6 bg-gray-200 rounded"></div>
                                <div class="h-6 bg-gray-200 rounded"></div>
                                <div class="h-6 bg-gray-200 rounded"></div>
                            </div>

                            <div class="grid grid-cols-3 gap-x-6 gap-y-9">
                                <div class="h-6 bg-gray-200 rounded"></div>
                                <div class="col-span-2 flex space-x-3">
                                    <div class="h-6 bg-gray-200 rounded w-1/3"></div>
                                    <div class="h-6 bg-gray-200 rounded w-1/3"></div>
                                    <div class="h-6 bg-gray-200 rounded w-1/3"></div>
                                </div>
                            </div>

                            <div class="grid grid-cols-2 gap-x-6 gap-y-9">
                                <div class="h-6 bg-gray-200 rounded"></div>
                                <div class="h-6 bg-gray-200 rounded"></div>
                                <div class="h-6 bg-gray-200 rounded"></div>
                                <div class="h-6 bg-gray-200 rounded"></div>
                            </div>

                            <div class="grid grid-cols-2 gap-x-6 gap-y-9">
                                <div class="h-6 bg-gray-200 rounded"></div>
                                <div class="h-6 bg-gray-200 rounded"></div>
                            </div>

                            <div class="grid grid-cols-2 gap-x-6 gap-y-9">
                                <div class="h-6 bg-gray-200 rounded"></div>
                                <div class="h-6 bg-gray-200 rounded"></div>
                                <div class="h-6 bg-gray-200 rounded"></div>
                                <div class="h-6 bg-gray-200 rounded"></div>
                                <div class="h-6 bg-gray-200 rounded"></div>
                            </div>
                        </div>

                        <div v-else class="space-y-9">
                              <!-- v-if="leaveDetails.leaveIcon" -->
                            <div class="relative w-36 h-28 rounded-md border-neutral-100 shadow-md border-l border-t border-r p-3">
                                <img :src="getLeaveIcon(leaveDetails)" alt="" srcset="" class="w-full h-full object-contain">
                            </div>

                            <div class="grid grid-cols-3 gap-x-6 gap-y-9">
                                <div class="flex items-center border-b border-neutral-300 space-x-1">
                                    <span class="shrink-0 pb-2 text-black text-sm font-normal">Name:</span>
                                    <p class="input-label">{{ leaveDetails.leaveName }}</p>
                                </div>
                                <div class="flex items-center border-b border-neutral-300 space-x-1">
                                    <span class="shrink-0 pb-2 text-black text-sm font-normal">Paid Leave:</span>
                                   <p class="input-label">{{ leaveDetails.paidLeave }}</p>
                                </div>
                                <div class="flex items-center border-b border-neutral-300 space-x-1">
                                    <span class="shrink-0 pb-2 text-black text-sm font-normal">Effective After:</span>
                                   <p class="input-label">{{ leaveDetails.effectiveAfter}} {{ leaveDetails.effectiveAfterDate}}</p>
                                </div>
                            </div>

                            <div class="grid grid-cols-3 gap-x-6 gap-y-9">
                                <!--  -->
                                <div class="flex items-center border-b border-neutral-300 space-x-3">
                                    <span class="shrink-0 pb-2 text-black text-sm font-normal">Leave Financial Year Wise:</span>
                                   <p class="input-label">{{ leaveDetails.leaveFinancialYear === 'true' ? 'Yes' : 'No' }}</p>
                                </div>
                                <!-- Leave Duration -->
                                <div class="col-span-2 flex items-center border-b border-neutral-300 space-x-3">
                                <span class="shrink-0 pb-2 text-black text-sm font-normal">Leave duration:</span>

                                <template v-if="leaveDetails.leaveFinancialYear === 'false'">
                                    <p class="input-label">{{ leaveDetails.leaveSpanFromDate }}</p>
                                    <span class="shrink-0 pb-2 text-black text-sm font-normal">to</span>
                                    <p class="input-label">{{ leaveDetails.leaveSpanToDate }}</p>
                                </template>

                                <template v-else>
                                    <p class="input-label">N/A</p>
                                </template>
                                </div>
                                <!--  -->
                            </div>

                            <div class="grid grid-cols-2 gap-x-6 gap-y-9">
                                <div class="flex items-center border-b border-neutral-300 space-x-3">
                                    <span class="shrink-0 pb-2 text-black text-sm font-normal">Leave Carry Forward:</span>
                                    <p class="input-label">{{ leaveDetails.leaveCarry === 'true' ? 'Yes' : 'No' }}</p>
                                </div>
                                <div class="flex items-center border-b border-neutral-300 space-x-3">
                                    <span class="shrink-0 pb-2 text-black text-sm font-normal">Leave Carry forward Limit:</span>
                                    <p class="input-label">{{ leaveDetails.leaveCarry === 'true' ? leaveDetails.leaveCurryFwdLimit : 'N/A' }}</p>
                                </div>
                               
                                <div class="flex items-center border-b border-neutral-300 space-x-3">
                                    <span class="shrink-0 pb-2 text-black text-sm font-normal">Leave Encashment:</span>
                                    <p class="input-label">{{ leaveDetails.leaveCncashment=== 'true' ? 'Yes' : 'No' }}</p>
                                </div>

                                <div class="flex items-center border-b border-neutral-300 space-x-3">
                                    <span class="shrink-0 pb-2 text-black text-sm font-normal">Leave Encashment Limit:</span>
                                    <p class="input-label">{{ leaveDetails.leaveCncashment=== 'true'? leaveDetails.leaveCncashmentLimit: 'N/A'}}</p>
                                </div>
                            </div>

                            <div class="grid grid-cols-2 gap-x-6 gap-y-9">
                                <div class="flex items-center border-b border-neutral-300 space-x-3">
                                    <span class="shrink-0 pb-2 text-black text-sm font-normal">Leave Applicable For:</span>
                                   <p class="input-label">{{ leaveDetails.leaveApplicableData }}</p>
                                </div>
                                <div class="flex items-center border-b border-neutral-300 space-x-3">
                                    <span class="shrink-0 pb-2 text-black text-sm font-normal">Marital Status:</span>
                                   <p class="input-label">{{ leaveDetails.MaritalStatusData }}</p>
                                </div>

                            </div>

                            <div class="grid grid-cols-2 gap-x-6 gap-y-9">
                                <div class="flex items-center border-b border-neutral-300 space-x-3">
                                    <span class="shrink-0 pb-2 text-black text-sm font-normal">Leave Duration:</span>
                                   <p class="input-label">{{ parseLeaveDuration(leaveDetails.leaveDuration) }}</p>
                                </div>
                                <div class="flex items-center border-b border-neutral-300 space-x-3">
                                    <span class="shrink-0 pb-2 text-black text-sm font-normal">Department:</span>
                                   <p class="input-label">{{ leaveDetails.leaveDepartment }}</p>
                                </div>
                                <div class="flex items-center border-b border-neutral-300 space-x-3">
                                    <span class="shrink-0 pb-2 text-black text-sm font-normal">Designation:</span>
                                   <p class="input-label">{{ leaveDetails.leaveDesignation }}</p>
                                </div>
                                <div class="flex items-center border-b border-neutral-300 space-x-3">
                                    <span class="shrink-0 pb-2 text-black text-sm font-normal">Location:</span>
                                   <p class="input-label">{{ leaveDetails.location=== 'yes'? 'Yes' :'No' }}</p>
                                </div>
                                <div class="flex items-center border-b border-neutral-300 space-x-3">
                                    <span class="shrink-0 pb-2 text-black text-sm font-normal">Sandwich Leave:</span>
                                   <p class="input-label">{{ leaveDetails.leaveSandwitch=== 'yes'? 'Yes' :'No' }}</p>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>    
            </div>
            <RightSideBar />
        </section>
    </AdminLayout>
</template>

<script>
    import AdminLayout from '../AdminDashboard/AdminLayout.vue';
    import RightSideBar from '../../components/RightSideBar.vue';
    import { BASE_URL, BASE_URL_POP } from "../../config";
    import axios from 'axios';
    export default {
        name: 'LeaveListing',
        components: {
            AdminLayout,
            RightSideBar,
        },
        data() {
            return {
                BASE_URL_POP:BASE_URL_POP, // or from .env
                leaveDetails: {}, // Store API response here
                loading:true,
                defaultIcons:{
                    casual: 'casual',
                    medical: 'medical',
                    sick: 'sick',
                    earned: 'earned',
                }
            };
        },
        mounted() {
        this.fetchLeaveDetails();
        },
        methods: {
            async fetchLeaveDetails() {
            this.loading = true;
            const id = this.$route.params.id; // assuming the route is like /leave-details/:id
            try {
                const response = await axios.get(`${BASE_URL}/view-leave/${id}`);
                this.leaveDetails = response.data.leavedataforview;
            } catch (error) {
                console.error('Failed to fetch leave details:', error);
            }finally {
                    this.loading = false;
            }
        },
        parseLeaveDuration(duration) {
            try {
                return duration ? JSON.parse(duration).join(", ") : "N/A";
            } catch (e) {
                return "N/A"; // Handle invalid JSON
            }
        },
        getLeaveIcon(leave) {
        // if (leave?.leaveIcon) {
        //     return `${this.BASE_URL_POP}media/leaveIcon/${leave.leaveIcon}`;
        // }

        if (leave?.leaveIcon && leave.leaveIcon.trim() !== '' && leave.leaveIcon.trim() !== "null" && leave.leaveIcon.trim() !== "undefined") {
            return `${this.BASE_URL_POP}media/leaveIcon/${leave.leaveIcon}`;
        }

        const normalized = leave?.leaveName?.toLowerCase() || '';
        const matchedKey = Object.keys(this.defaultIcons).find(key =>
            normalized.includes(key)
        );

        if (matchedKey && this.defaultIcons[matchedKey]) {
            return require(`@/assets/${matchedKey}.png`);
        }

        return require('@/assets/default.png');
        }

            
        }
    }
</script>

<style scoped>
/* Remove default input focus */
input:focus {
    outline: none;
}
/* Skeleton animation */
@keyframes pulse {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
}

.animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>
